import { Link } from 'react-router-dom'

const Prevencion = () => {
   return (
      <>
         <div className="section animated fadeIn">
   
            {/* TÍTULO DE LA SECCIÓN */}
            <div className="row mb-title center mb-4">
               <div className="col s12 m12 l12 x12">
                  <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                     PREVENCIÓN
                  </h4>
               </div>
            </div>

            {/* TARJETA CONTENEDORA */}
            <div className="row justify-content-center">
               <div className="col s12 m12 l12">
                  <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '30px' }}>
                     
                     {[
                        {
                           titulo: 'Relevamiento de Agentes de Riesgo (RAR)',
                           url: `${process.env.REACT_APP_API_URL}/web/download/RAR.xlsx`
                        },
                        {
                           titulo: 'Relevamiento General de Riesgos Laborales – RGRL Dec. 351 – Comercio e Industria',
                           url: `${process.env.REACT_APP_API_URL}/web/download/D351.pdf`
                        },
                        {
                           titulo: 'Relevamiento General de Riesgos Laborales – RGRL Dec. 911 – Construcción',
                           url: `${process.env.REACT_APP_API_URL}/web/download/D911.pdf`
                        },
                        {
                           titulo: 'Relevamiento General de Riesgos Laborales – RGRL Dec. 617 – Agro',
                           url: `${process.env.REACT_APP_API_URL}/web/download/D617.pdf`
                        },
                        {
                           titulo: 'Aviso de Obra',
                           url: `${process.env.REACT_APP_API_URL}/web/download/AvisoDeObra.pdf`
                        },
                        {
                           titulo: 'Listado de Agentes de Riesgos',
                           url: `${process.env.REACT_APP_API_URL}/web/download/AgentesDeRiesgo.pdf`
                        },
                        {
                           titulo: 'Planilla de Registro de Entrega de EPP Res. N° 299/11',
                           url: `${process.env.REACT_APP_API_URL}/web/download//FormularioEPP.xls`
                        },
                        {
                           titulo: 'Manual de buenas prácticas en el Cultivo de Tabaco',
                           url: `${process.env.REACT_APP_API_URL}/web/download/ManualBuenasPracticasTabaco2019ModJulio2020.pdf`
                        },
                        {
                           titulo: 'Código CIUO (Clasificación Internacional Uniforme de Ocupaciones)',
                           url: `${process.env.REACT_APP_API_URL}/web/download/CodigosCIUO.pdf`
                        },
                        {
                           titulo: 'Código CIIUR4 (Clasificación Internacional Industrial Uniforme)',
                           url: `${process.env.REACT_APP_API_URL}/web/download/ciiur4.pdf`
                        },
                        {
                           titulo: 'Instructivo Carga de RAR - WEB Y Físico',
                           url: `${process.env.REACT_APP_API_URL}/web/download/InstructivoCargaDeRARWebFisico.pdf`,
                           conAncla: true
                        }
                     ].map((item, idx, arr) => (
                        <div key={idx}>
                           <div 
                              className="row valign-wrapper" 
                              style={{ 
                                 display: 'flex', 
                                 alignItems: 'center', 
                                 marginBottom: idx === arr.length - 1 && !item.conAncla ? '0' : '15px', 
                                 paddingBottom: idx === arr.length - 1 && !item.conAncla ? '0' : '15px', 
                                 borderBottom: idx === arr.length - 1 ? 'none' : '1px solid #e0e0e0' 
                              }}
                           >
                              <div className="col s8 m9 l10">
                                 <h6 className="grey-text text-darken-3" style={{ fontWeight: '600', margin: '0', fontSize: '1rem' }}>
                                    {item.titulo}
                                 </h6>
                              </div>
                              <div className="col s4 m3 l2 center-align">
                                 <a 
                                    href={item.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                                    style={{ borderRadius: '4px', textTransform: 'none', width: '100%' }}
                                 >
                                    Descargar
                                    <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '5px' }}>cloud_download</i>
                                 </a>
                              </div>
                           </div>
                           {item.conAncla && <div id="seccionSiniestros" />}
                        </div>
                     ))}

                  </div>
               </div>
            </div>

         </div>
      </>
   )
}

export default Prevencion